import { z } from "zod/v4";

import { castToBool } from "../../../utils";

export const UpdateShopifyPricesRequestBodySchema = z.object({
  variationId: z.uuid().optional(),
});

export type UpdateShopifyPricesRequestBodyType = z.infer<
  typeof UpdateShopifyPricesRequestBodySchema
>;

export const UpdateShopifyPricesPathParamsSchema = z.object({
  experienceId: z.uuid(),
});

export type UpdateShopifyPricesPathParamsType = z.infer<
  typeof UpdateShopifyPricesPathParamsSchema
>;

export const UpdateShopifyPricesRequestQueryParamsSchema = z.object({
  saveToS3: castToBool.optional(),
});

export type UpdateShopifyPricesRequestQueryParamsType = z.infer<
  typeof UpdateShopifyPricesRequestQueryParamsSchema
>;
